export default class ApiAlreadyHandled {
  type: 'already_handled';

  constructor() {
    this.type = 'already_handled';
  }
}
